import Card, { CardProps } from '@/components/base/Card'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'

import { archiveGridRevealAnimation } from './animations'
import { Section } from '@/types'

type ArchiveGridProps = Section & {
  collection?: CardProps[]
}

const ArchiveGrid = ({ collection, ...props }: ArchiveGridProps) => {
  return (
    <Motion animation={archiveGridRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-sm md:gap-y-md">
              {collection?.map((card) => (
                <div
                  key={`card-${card.uuid}`}
                  className="col-span-2 md:col-span-3 lg:col-span-4"
                >
                  <Card {...card} />
                </div>
              ))}
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default ArchiveGrid
